import { FC } from 'react';
import { createPortal } from 'react-dom';
import FontBody1 from '../../../../components/fonts/font-body1/font-body1';
import FontHeading3 from '../../../../components/fonts/font-heading3/font-heading3';
import { FONT_COLOR, FONT_VARIANT } from '../../../../components/fonts/font-props';
import RoundLoader, { RoundLoaderType } from '../../../../components/loaders/round-loader/round-loader';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';

import './plan-approval-redirect-overlay.scss';

const TRANSLATION_SCOPE = 'dashboard-home';

const PlanApprovalRedirectOverlay: FC = () => {
    const { getTranslation } = useDashboardTranslation();

    return createPortal(
        (
            <div className="plan-approval-redirect-overlay" role="status" aria-live="polite">
                <div className="plan-approval-redirect-overlay__panel">
                    <RoundLoader type={RoundLoaderType.Dark} />
                    <FontHeading3 color={FONT_COLOR.NEUTRAL11_MENU} variant={[FONT_VARIANT.BOLD]}>
                        {getTranslation('PLAN_APPROVAL_REDIRECTING_TITLE', TRANSLATION_SCOPE)}
                    </FontHeading3>
                    <FontBody1 color={FONT_COLOR.NEUTRAL10}>
                        {getTranslation('PLAN_APPROVAL_REDIRECTING_DESCRIPTION', TRANSLATION_SCOPE)}
                    </FontBody1>
                </div>
            </div>
        ),
        document.body,
    );
};

export default PlanApprovalRedirectOverlay;
